import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core'; // IMPORTANTE: EventEmitter desde @angular/core
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-multiple-select',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule
  ],
  templateUrl: './multiple-select.component.html',
  styleUrl: './multiple-select.component.scss'
})
export class MultipleSelectComponent {
  @Input() ids: any[] = []; // IDs ya seleccionados
  @Input() items: any[] = []; // Lista total de {id, name}
  @Input() label: string = '';
  
  @Output() selectionChange = new EventEmitter<any[]>(); // Emisor de cambios

  isPanelOpen = false;

  // Se ejecuta cada vez que el usuario marca/desmarca algo
  onModelChange(newValues: any[]): void {
    this.selectionChange.emit(newValues);
  }

  get selectedTriggerText(): string {
    if (!this.ids || this.ids.length === 0) return '';

    // Encontramos el nombre del primer item seleccionado para el resumen
    const firstItem = this.items.find(t => t.id === this.ids[0]);
    const firstSelectionName = firstItem ? firstItem.name : 'Seleccionado';
    
    const count = this.ids.length;
    return count === 1 ? firstSelectionName : `${firstSelectionName} (+${count - 1})`;
  }
}